export enum OrderTypeNameIds
{
    PurchaseOrder = "PurchaseOrder",
    SalesOrder = "SalesOrder",
    AssemblyOrder = "AssemblyOrder",
    PhysicalInventoryOrder = "PhysicalInventoryOrder"
}